module.exports = {"450405001":"大塘街道","450405002":"兴龙街道","450405101":"长洲镇","450405102":"倒水镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450405.json
// module id = 1936
// module chunks = 0